import axios, { CreateAxiosDefaults } from 'axios';

import { BookingApi, CommonApi, DiagrammingApi, InventoryApi } from './openapi/api.js';
import { Configuration } from './openapi/configuration.js';

export interface ClientOptions extends CreateAxiosDefaults<any> {
  basePath: string;
}

/**
 * Create an instance of the ApiClient class using axios as the http client with defaults.
 */
export const createClient = ({ basePath, ...restOpts }: ClientOptions) => {
  const configuration = new Configuration({
    basePath,
  });

  const axiosInstance = axios.create(restOpts);

  return {
    inventory: new InventoryApi(configuration, undefined, axiosInstance),
    booking: new BookingApi(configuration, undefined, axiosInstance),
    common: new CommonApi(configuration, undefined, axiosInstance),
    diagramming: new DiagrammingApi(configuration, undefined, axiosInstance),
  };
};

export default createClient;
